import { STORAGE_LANGUAGE } from '../constants/storage'

export const getLanguage = () => {
  const availableLangs = {
    en: 'en',
    uz: 'uz',
  }
  const selectedLang = availableLangs[(localStorage.getItem(STORAGE_LANGUAGE) as 'uz' | 'en') || 'uz'] as 'uz' | 'en'
  return selectedLang
}

export const setLanguage = (lang: 'uz' | 'en') => {
  localStorage.setItem(STORAGE_LANGUAGE, lang)
}

export const removeLanguage = () => {
  localStorage.removeItem(STORAGE_LANGUAGE)
}
